import React from 'react';

import Radio from '@mui/material/Radio';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';

export default function StyledCheckbox(props) {
    return (
        <Radio
            checkedIcon={<CheckBoxIcon sx={{ color: 'var(--sipzee-green)', fontSize:40 }} />}
            icon={<CheckBoxOutlineBlankIcon sx={{ color: 'var(--sipzee-gray)', fontSize: 40 }} />}
            inputProps={{ 'aria-label': 'select one' }}
            style={{padding:'7px'} }
            {...props}
        />
    );
}